import logo from "../../assets/images/logo.png";
import logo2 from "../../assets/images/logo2.png";
import slide1 from "../../assets/images/slider/slide-1.png";
import slide2 from "../../assets/images/slider/slide-2.png";
import slide3 from "../../assets/images/slider/slide-3.png";
import icon1 from "../../assets/images/icon/icon1.png";
import icon2 from "../../assets/images/icon/icon2.png";
import icon3 from "../../assets/images/icon/icon3.png";
import icon4 from "../../assets/images/icon/icon4.png";
import icon5 from "../../assets/images/icon/icon5.png";
import icon6 from "../../assets/images/icon/icon6.png";
import icon7 from "../../assets/images/icon/icon7.png";
import icon8 from "../../assets/images/icon/icon8.png";
import icon9 from "../../assets/images/icon/icon9.png";
import category1 from "../../assets/images/category/category1.png";
import category2 from "../../assets/images/category/category2.png";
import category3 from "../../assets/images/category/category3.png";
import category4 from "../../assets/images/category/category4.png";
import category5 from "../../assets/images/category/category5.png";
import category6 from "../../assets/images/category/category6.png";
import printingBlock from "../../assets/images/printing-block.png";
import homeBg from "../../assets/images/home-bg.png";
import shape1 from "../../assets/images/shapes/shape1.png";
import rugs from "../../assets/images/rugs.jpg";
import table from "../../assets/images/table.jpg";
import wallhanging from "../../assets/images/wallhanging.jpg";
import homedecor from "../../assets/images/homedecor.jpg";
import cushions from "../../assets/images/cushions.png";
import dolls from "../../assets/images/dolls.png";
import printingblock2 from "../../assets/images/printing-block2.png";
import printingblock3 from "../../assets/images/printing-block3.png";
import printingblock4 from "../../assets/images/printing-block4.png";
import bestseller1 from "../../assets/images/bestseller1.png";
import bestseller2 from "../../assets/images/bestseller2.png";
import bestseller3 from "../../assets/images/bestseller3.png";
import bestseller4 from "../../assets/images/bestseller4.png";
import bestseller5 from "../../assets/images/bestseller5.png";
import newarrival1 from "../../assets/images/newarrival1.png";
import newarrival2 from "../../assets/images/newarrival2.png";
import fabric1 from "../../assets/images/fabric1.png";
import fabric2 from "../../assets/images/fabric2.png";
import fabric3 from "../../assets/images/fabric3.png";
import fabric4 from "../../assets/images/fabric4.png";
import fabric5 from "../../assets/images/fabric5.png";
import gallery1 from "../../assets/images/gallery1.jpg";
import gallery2 from "../../assets/images/gallery2.jpg";
import gallery3 from "../../assets/images/gallery3.jpg";
import gallery4 from "../../assets/images/gallery4.jpg";
import gallery5 from "../../assets/images/gallery5.jpg";
import insta1 from "../../assets/images/insta1.jpg";
import insta2 from "../../assets/images/insta2.jpg";
import insta3 from "../../assets/images/insta3.jpg";
import insta4 from "../../assets/images/insta4.jpg";
import insta5 from "../../assets/images/insta5.jpg";
import fb from "../../assets/images/social/fb.png";
import insta from "../../assets/images/social/insta.png";
import whatsapp from "../../assets/images/social/whatsapp.png";
import YouTube from "../../assets/images/social/YouTube.png";
import logo_white from "../../assets/images/logo_white.png";
import loader from "../../assets/images/loader.gif";
import tape_measure from "../../assets/images/tape_measure.png";
import scissors from "../../assets/images/scissors.png";
import down_arrow from "../../assets/images/icon/down-arrow.png";
import aed from "../../assets/images/currency/aed.png";
import aud from "../../assets/images/currency/aud.webp";
import eur from "../../assets/images/currency/eur.png";
import gbp from "../../assets/images/currency/gbp.png";
import inr from "../../assets/images/currency/inr.png";
import usd from "../../assets/images/currency/usa.png";
import about_bg from "../../assets/images/about_bg.jpg";
import about_left from "../../assets/images/about_left.png";
import about_fabric1 from "../../assets/images/about_fabric1.png";
import about_fabric2 from "../../assets/images/about_fabric2.png";
import about_fabric3 from "../../assets/images/about_fabric3.png";
import choose2 from "../../assets/images/choose-2.png";
import choose1 from "../../assets/images/choose-1.png";
import choose3 from "../../assets/images/choose-3.png";
import process1 from "../../assets/images/process1.png";
import process2 from "../../assets/images/process2.png";
import process3 from "../../assets/images/process3.png";
import faq_bg from "../../assets/images/faq_bg.jpg";
import blog1 from "../../assets/images/blog1.jpg";
import blog2 from "../../assets/images/blog2.jpg";
import blog3 from "../../assets/images/blog3.jpg";
import blog4 from "../../assets/images/blog4.jpg";
import blog_detail1 from "../../assets/images/blog_detail1.webp";
import blog_detail2 from "../../assets/images/blog_detail2.jpg";
import blog_detail3 from "../../assets/images/blog_detail3.webp";
import blog_detail4 from "../../assets/images/blog_detail4.webp";
import blog_detail5 from "../../assets/images/blog_detail5.webp";
import home_popup from "../../assets/images/home-popup.png";
import home_popup2 from "../../assets/images/home-popup2.jpeg";
import home_popup3 from "../../assets/images/home-popup3.jpg";
import whatsapp_offer from "../../assets/images/whatsapp_offer.png";
import blogs_img from "../../assets/images/blogs_img.png";
import faq_img from "../../assets/images/faq_img.png";
import product1 from "../../assets/images/product1.webp";
import product2 from "../../assets/images/product2.webp";
import product3 from "../../assets/images/product3.webp";
import card_games from "../../assets/images/icon/card-games.png";
import gift from "../../assets/images/icon/gift.png";
import secure from "../../assets/images/icon/secure.png";
import dispatch from "../../assets/images/icon/dispatch.png";
import party from "../../assets/images/icon/party.png";
import rating from "../../assets/images/icon/rating.png";
import category_bg2 from "../../assets/images/category-bg2.png";
import empty_wishlist from "../../assets/images/empty/wishlist.png";
import empty_cart from "../../assets/images/empty/cart.webp";
import razorpay_logo from "../../assets/images/razorpay.png"

export const images = {
  tape_measure,rating,category_bg2,empty_wishlist,empty_cart,
  party,
  whatsapp_offer,
  product1,
  gift,
  blog1,
  blogs_img,
  product2,
  secure,
  home_popup2,
  faq_img,
  product3,
  card_games,
  dispatch,
  blog_detail1,
  home_popup3,
  home_popup,
  choose2,
  faq_bg,
  blog2,
  blog_detail2,
  icon6,
  blog3,
  blog_detail3,
  process1,
  blog4,
  choose1,
  blog_detail4,
  blog_detail5,
  icon7,
  process2,
  choose3,
  icon8,
  process3,
  about_fabric1,
  icon9,
  down_arrow,
  about_fabric2,
  about_left,
  aed,
  about_fabric3,
  loader,
  aud,
  about_bg,
  scissors,
  eur,
  logo_white,
  gbp,
  fb,
  inr,
  insta,
  usd,
  whatsapp,
  YouTube,
  insta1,
  insta2,
  insta3,
  insta4,
  insta5,
  gallery1,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  fabric1,
  fabric2,
  fabric3,
  fabric4,
  fabric5,
  newarrival1,
  newarrival2,
  bestseller1,
  bestseller2,
  bestseller3,
  bestseller4,
  bestseller5,
  printingblock2,
  printingblock3,
  printingblock4,
  dolls,
  logo,
  logo2,
  slide1,
  slide2,
  slide3,
  icon1,
  icon2,
  icon3,
  icon4,
  icon5,
  category1,
  category2,
  category3,
  category4,
  category5,
  category6,
  printingBlock,
  homeBg,
  shape1,
  rugs,
  table,
  wallhanging,
  homedecor,
  cushions,
  razorpay_logo,
};
